import React from 'react';
export interface MultipleChoiceOption {
  id: string;
  label: string;
  icon?: string;
}
interface MultipleChoiceWidgetProps {
  question: string;
  options: MultipleChoiceOption[];
  onSelect: (optionId: string) => void;
}
export function MultipleChoiceWidget({
  question,
  options,
  onSelect
}: MultipleChoiceWidgetProps) {
  return <div className="mt-3 bg-white border border-yeppy-text border-opacity-15 rounded-2xl p-4" data-id="element-435">
      <p className="font-poppins text-sm font-medium mb-3" style={{
      color: '#1D2A36'
    }} data-id="element-436">
        {question}
      </p>
      <div className="flex flex-wrap gap-2" data-id="element-437">
        {options.map(option => <button key={option.id} onClick={() => onSelect(option.id)} className="px-4 py-2 rounded-full font-poppins text-sm font-medium text-yeppy-text bg-yeppy-bg border border-yeppy-text border-opacity-10 transition-all active:scale-95" data-id="element-438">
            {option.icon && <span className="mr-2" data-id="element-439">{option.icon}</span>}
            {option.label}
          </button>)}
      </div>
    </div>;
}